import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { t_cpap_instructions } from 'types';
import { getDataStoreFields } from './RegisterFirstStep/thunk';
import { newOrder } from './thunks';

interface InitialState {
  medical: {
    id?: string;
    isUpdated: boolean;
  };
  cpapInstructions: t_cpap_instructions;
  dataStoreFields?: any[];
  dataStoreMedicalFields?: any[];
}

const initialState: InitialState = {
  cpapInstructions: {},
  medical: {
    isUpdated: false,
  },
};

const registerSlices = createSlice({
  name: 'register',
  initialState,
  reducers: {
    newPatient(state, action: PayloadAction<t_cpap_instructions>) {
      return { ...state, cpapInstructions: action.payload };
    },
    resetState(state) {
      return { ...state, cpapInstructions: {}, medical: { id: undefined, isUpdated: false } };
    },
    setMedical(state, action: PayloadAction<{ medicalId: string | undefined; isUpdate: boolean }>) {
      return { ...state, medical: { id: action.payload.medicalId, isUpdated: action.payload.isUpdate } };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(newOrder.fulfilled, (state, action) => {});
    builder.addCase(getDataStoreFields.fulfilled, (state, action) => ({
      ...state,
      dataStoreFields: Object.entries(action.payload.data.fields),
    }));
  },
});

export const { newPatient, resetState, setMedical } = registerSlices.actions;

export default registerSlices.reducer;
